class IngredientCarousel extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return super.requiredElements.concat(['dot'])
  }

  initialiseCarousel () {
    let tabletSlides = 3
    let desktopSlides = 4

    if (this.els.slide.elements.length > 3) {
      tabletSlides = 2.5
    } else if (this.els.slide.elements.length < 3) {
      tabletSlides = this.els.slide.elements.length
    }
    if (this.els.slide.elements.length > 4) {
      desktopSlides = 3.5
    } else if (this.els.slide.elements.length < 4) {
      desktopSlides = this.els.slide.elements.length
    }

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            slides: {
              perView: tabletSlides,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.lg +
            1}px)`]: {
            slides: {
              perView: desktopSlides,
            },
          },
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useDots(this.els.dot.elements),
      ],
    )
  }
}

if (!customElements.get('ingredient-carousel')) {
  customElements.define('ingredient-carousel', IngredientCarousel)
}
